<template>
  <div class="common-share">
    <img class="img" src="./imgs/bg.png" />
    <div class="bottom-box">
      <div class="text-img">
        <span class="share_text1">完成注册认证后可领取4.9元红包</span>
      </div>
      <div class="text-img">
        <span class="share_text2">邀请1人认证，可再次领取4.9元红包</span>
      </div>
      <notice />
      <div class="button-wrp">
        <img class="btn" @click="to" src="./imgs/btn.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import notice from './notice'
export default {
  name: 'other-share',
  components: {
    notice,
  },
  data() {
    return {
      inviteSysUserId: '',
    }
  },
  mounted() {
    this.inviteSysUserId = this.$route.query.inviteSysUserId
      ? this.$route.query.inviteSysUserId
      : ''
  },
  methods: {
    to() {
      this.$router.push(
        `/activity/act-login?inviteSysUserId=${this.inviteSysUserId}&inviteSource=1`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.common-share {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #472bbf;
  ::v-deep .van-icon {
    color: #111111;
  }
  ::v-deep .buyer-show .notice-swipe {
    color: #fff;
  }
  .img {
    width: 100%;
  }
  .bottom-box {
    position: absolute;
    width: 100%;
    bottom: 0px;
    .button-wrp {
      text-align: center;
      .btn {
        width: 315px;
      }
    }
    .text-img {
      text-align: center;
      .share_text1 {
        text-align: center;
        opacity: 0.4;
      }
      .share_text2 {
        margin-top: 0px;
        opacity: 0.6;
      }
      span {
        display: inline-block;
        font-size: 12px;
        padding: 2px 0;
        color: #fff;
      }
      @media screen and (max-height: 315px) {
        display: none;
      }
    }
    .text {
      text-align: center;
      color: #51b4ff;
      margin-bottom: 10px;
      font-size: 13px;
    }
  }
}
</style>